import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { CdkMenuModule } from '@angular/cdk/menu';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';

import { MinuteRequestApproveRuleSettingRoutingModule } from './minute-request-approve-rule-setting-routing.module';
import { MinuteRequestApprovalRuleIndexComponent } from './minute-request-approval-rule-index/minute-request-approval-rule-index.component';
import { MinuteRequestApprovalRuleTableComponent } from './components/minute-request-approval-rule-table/minute-request-approval-rule-table.component';
import { MinuteRequestApprovalRuleDetailComponent } from './components/minute-request-approval-rule-detail/minute-request-approval-rule-detail.component';
import { RegisterMinuteApprovalRuleModalComponent } from './components/register-minute-approval-rule-modal/register-minute-approval-rule-modal.component';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { UpdateMinuteRequestApprovalRuleComponent } from './components/update-minute-request-approval-rule/update-minute-request-approval-rule.component';
import { UpdateMinuteRequestApprovalRuleConditionComponent } from './components/update-minute-request-approval-rule-condition/update-minute-request-approval-rule-condition.component';
import { RegisterMinuteRequesApprovalConditionsComponent } from './components/register-minute-reques-approval-conditions/register-minute-reques-approval-conditions.component';
import { MatSortModule } from '@angular/material/sort';
import { MinuteApprovalConditionFormGroupComponent } from './components/minute-approval-condition-form-group/minute-approval-condition-form-group.component';

const MATERIAL_MODULES = [
  MatButtonModule,
  MatTableModule,
  MatInputModule,
  MatChipsModule,
  MatCardModule,
  MatIconModule,
  MatDialogModule,
  MatSelectModule,
  MatMenuModule,
  MatPaginatorModule,
  MatCheckboxModule,
  MatProgressSpinnerModule,
  MatSortModule
];


@NgModule({
  declarations: [
    MinuteRequestApprovalRuleIndexComponent,
    MinuteRequestApprovalRuleTableComponent,
    MinuteRequestApprovalRuleDetailComponent,
    RegisterMinuteApprovalRuleModalComponent,
    UpdateMinuteRequestApprovalRuleComponent,
    UpdateMinuteRequestApprovalRuleConditionComponent,
    RegisterMinuteRequesApprovalConditionsComponent,
    MinuteApprovalConditionFormGroupComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MinuteRequestApproveRuleSettingRoutingModule,
    MATERIAL_MODULES,
    NgxMaskDirective,
    NgxMaskPipe,
    CdkMenuModule,
    TablerIconsModule.pick(TablerIcons),
  ],
  exports: [TablerIconsModule]
})
export class MinuteRequestApproveRuleSettingModule { }
